<template>
  <div class="page-header">
    <div class="page-header__container">
      <div class="page-header__title" data-test="page-header__title">
        {{ title }}
      </div>
      <div class="page-header__cart-preview" v-if="shouldDisplayCart">
        <el-button class="page-header__cart-preview--button"
                   type=""
                   @click="bubbleUpCartEvent" plain>
          <i class="el-icon-shopping-cart-2"></i>
          Récapitulatif Panier
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      shouldDisplayCart: Boolean,
    },
    methods: {
      bubbleUpCartEvent() {
        this.$emit('displayCartPreview');
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '../../assets/css/main.styl';

  .page-header {
    margin-bottom 20px;
    width: 100%;
    height: 90px;
    background: $secondary-color;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .page-header__container {
    padding-left: 150px;
    padding-right 150px
    display flex
    flex-direction row
    justify-content space-between
  }

  .page-header__title {
    color: #fff;
    font-size: $main-title-size;
  }

  .page-header__cart-preview {
  }

  .page-header__cart-preview--button {
    background-color $highlight-color
    color $secondary-color
    &:hover {
      background-color $hover-color
      color $secondary-color
      border-color $hover-color
    }
  }
</style>
